<template>
  <v-container>
    <v-card class="mx-auto pa-4">
      <div id="chart">
        <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>

      <v-row>
        <v-col id="select" cols="2">
          <v-select v-model="selectedValueOption" :items="valueOptions" v-on:change="updateChart()" label="Graph Type">
          </v-select>
        </v-col>
        <v-col id="includeAcumaticaPrice" cols="3">
          <div class="float-left">
            <v-checkbox class="caption" v-model="includeAcumaticaPrices" label="Include Acumatica Price"
              v-on:change="updateChart()">
            </v-checkbox>
          </div>
        </v-col>
        <v-col id="startAtZero" cols="2">
          <div class="float-left">
            <v-checkbox class="caption" v-model="startYAxisAtZero" label="Start Y-Axis at 0"
              v-on:change="updateChart()">
            </v-checkbox>
          </div>
        </v-col>
        <v-col id="timeFrame" cols="5">
          <div class="float-right">
            <v-radio-group v-model="timeFrame" label="Timeframe:" row @change="updateChart()">
              <v-radio label="6 Months" value="6" />
              <v-radio label="12 Months" value="12" />
              <v-radio label="24 Months" value="24" />
              <v-radio label="Max" value="40" />
            </v-radio-group>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { AcumaticaPriceService } from '../../services/api/acumaticaPrice';
import { MarketplacesService } from '../../services/api/marketplaces';
import { SnapshotsService } from '../../services/api/snapshots';
const apiAcumaticaPrice = new AcumaticaPriceService();
const apiMarketplaces = new MarketplacesService();
const apiSnapshots = new SnapshotsService();

import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    catCodeString: String
  },

  data: function () {
    return {
      marketplaces: [],
      snapshots: [],
      valueOptions: ["Refined", "QtyCap", "US", "All"],  // Which value set to show on the graph
      timeFrame: "6", // Default timeframe for the snapshots
      selectedValueOption: "",
      includeAcumaticaPrices: false,
      startYAxisAtZero: false,
      acumaticaPrices: [],

      series: [
        {
          name: "",
          color: "#00000000",
          data: []
        },
        {
          name: "",
          color: "#00000000",
          data: []
        },
        {
          name: "",
          color: "#00AA0066",
          data: []
        },
        {
          name: "",
          color: "#00AA00DD",
          data: []
        },
        {
          name: "",
          color: "#EF642166",
          data: []
        },
        {
          name: "",
          color: "#EF6421DD",
          data: []
        },
        {
          name: "",
          color: "#9EB00066",
          data: []
        },
        {
          name: "",
          color: "#9EB000DD",
          data: []
        },
      ],

      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          },
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true
        },

        stroke: {
          curve: 'straight'
        },
        title: {
          text: 'Listings Snapshot History',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          //categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
          categories: [],
          labels: {
            rotateAlways: true,
          }
        },
        // TODO: make a colors array and pull the strings from that component-scoped array
        yaxis: [{
          show: true,
          title: { text: 'Qty', style: { color: '#000000AA' } },
        }, {
          show: true,
          title: { text: 'Price', style: { color: '#000000AA' } },
        }]
      },
    }
  },

  created: function () {
    this.selectedValueOption = "Refined";
    //selectedValueOption = "Refined";

    this.updateChart();
    return;
  },

  methods: {
    updateChart() {
      console.log(`updateChart, selectedValueOption= ${this.selectedValueOption}, includeAcumaticaPrices= ${this.includeAcumaticaPrices}`);

      apiMarketplaces.getMarketplaces().then((data) => {
        this.marketplaces = data;
        for (const marketplace of this.marketplaces) {
          marketplace.previousPrice = null;
        }

        if (this.includeAcumaticaPrices) {
          apiAcumaticaPrice.getAcumaticaPrices(this.catCodeString).then((data) => {
            this.acumaticaPrices = data.map(ap => ({ ...ap, date: new Date(ap.date) }));
            this._buildChart();
          });
        } else {
          this.acumaticaPrices = [];
          this._buildChart();
        }
      });
    },
    _mapSnapshotToAcumaticaPrice(snapshot, priceName) {
      let index = findLastIndex(this.acumaticaPrices, ap => ap.date.getTime() >= snapshot.scanEndDateTime.getTime());
      if (index >= 0) return this.acumaticaPrices[index][priceName];
      else return null;
    },
    _mapDateToAcumaticaPrice(date, priceName) {
      let index = findLastIndex(this.acumaticaPrices, ap => ap.date.getTime() <= date.getTime());
      if (index >= 0) return this.acumaticaPrices[index][priceName];
      else return null;
    },
    _mapDateToValue(date, marketplace, valueCallback) {
      let index;
      if (marketplace.hasSoldItems) {
        index = findLastIndex(this.snapshots, s => s.marketplaceID === marketplace.id && date.getTime() <= s.scanEndDateTime.getTime());
      } else {
        index = findLastIndex(this.snapshots, s => s.marketplaceID === marketplace.id && date.getTime() >= s.scanEndDateTime.getTime());
      }
      // console.log(date, marketplace.id, index);
      if (index >= 0) return valueCallback(this.snapshots[index]);
      else return null;

      // find the snapshot immediate before and after the date
      // and interpolate the value between the two snapshots

      // const snapshotAfterIndex = this.snapshots.findIndex(s => s.scanEndDateTime.getTime() > date.getTime());
      // let snapshotBeforeIndex;
      // if (snapshotAfterIndex === 0) {
      //   snapshotBeforeIndex = -1;
      // } else if (snapshotAfterIndex > 0) {
      //   snapshotBeforeIndex = snapshotAfterIndex - 1;
      // } else {
      //   snapshotBeforeIndex = findLastIndex(this.snapshots, s => s.scanEndDateTime.getTime() <= date.getTime());
      // }

      // let snapshotBefore = snapshotBeforeIndex >= 0 ? this.snapshots[snapshotBeforeIndex] : null;
      // let snapshotAfter = snapshotAfterIndex >= 0 ? this.snapshots[snapshotAfterIndex] : null;

      // let beforeValue = null;
      // let afterValue = null;

      // if (snapshotBefore) {
      //   const snapshotBeforeDateDiffInDays = Math.round((date.getTime() - snapshotBefore.scanEndDateTime.getTime()) / (1000 * 3600 * 24));
      //   console.log('snapshotBeforeDateDiffInDays', snapshotBeforeDateDiffInDays);
      //   if (snapshotBeforeDateDiffInDays === 0) {
      //     return valueCallback(snapshotBefore);
      //   } else if (snapshotBeforeDateDiffInDays > 7) {
      //     snapshotBefore = null;
      //   } else {
      //     beforeValue = valueCallback(snapshotBefore);
      //   }
      // }

      // if (snapshotAfter) {
      //   const snapshotAfterDateDiffInDays = Math.round((snapshotAfter.scanEndDateTime.getTime() - date.getTime()) / (1000 * 3600 * 24));
      //   console.log('snapshotAfterDateDiffInDays', snapshotAfterDateDiffInDays);
      //   if (snapshotAfterDateDiffInDays === 0) {
      //     return valueCallback(snapshotAfter);
      //   } else if (snapshotAfterDateDiffInDays > 7) {
      //     snapshotAfter = null;
      //   } else {
      //     afterValue = valueCallback(snapshotAfter);
      //   }
      // }

      // console.log('beforeValue', beforeValue, 'afterValue', afterValue);

      // if (beforeValue && afterValue) {
      //   return (beforeValue + afterValue) / 2;
      // } else if (beforeValue) {
      //   return beforeValue;
      // } else if (afterValue) {
      //   return afterValue;
      // } else {
      //   return null;
      // }
    },
    _mapDateToMarketplaceQty(date, marketplace) {
      const qty = this._mapDateToValue(date, marketplace, s => this._mapSnapshotToMarketplaceQty(s, marketplace, date));
      // console.log('qty', qty);
      return qty ? _.round(qty, 2) : null;
    },
    _mapSnapshotToMarketplaceQty(snapshot, marketplace, date) {
      // console.log('snapshot', snapshot, 'marketplace', marketplace);
      if (snapshot.marketplaceID !== marketplace.id) return marketplace.previousQty || null;

      let qty = null;
      if (marketplace.hasSoldItems) {
        const soldItems = snapshot.soldItems.filter(si => new Date(si.dateSold).getTime() >= date.getTime() && new Date(si.dateSold).getTime() <= (date.getTime() + 1000 * 3600 * 24 * 7));
        qty = soldItems.length;
      } else {
        switch (this.selectedValueOption) {
          case "All":
          case "US":
            qty = snapshot.activeTotalQty;
            break;
          case "QtyCap":
            qty = snapshot.qtyCapTotalQty;
            break;
          case "Refined":
          default:
            qty = snapshot.refinedTotalQty;
            break;
        }
        marketplace.previousQty = qty;
      }
      return qty;
    },
    _mapDateToMarketplacePrice(date, marketplace) {
      const price = this._mapDateToValue(date, marketplace, s => this._mapSnapshotToMarketplacePrice(s, marketplace, date));
      return price ? _.round(price, 2) : null;
    },
    _mapSnapshotToMarketplacePrice(snapshot, marketplace, date) {
      if (snapshot.marketplaceID !== marketplace.id) return marketplace.previousPrice || null;

      let price = null;
      if (marketplace.hasSoldItems) {
        const soldItems = snapshot.soldItems.filter(si => new Date(si.dateSold).getTime() >= date.getTime() && new Date(si.dateSold).getTime() <= (date.getTime() + 1000 * 3600 * 24 * 7));
        if (soldItems.length > 0) {
          price = _.round(soldItems.reduce((sum, si) => sum + si.salePrice, 0) / soldItems.length, 2);
          console.log('soldItems', soldItems, 'price', price);
        }
      } else {
        if (this.selectedValueOption == "All") {
          price = snapshot.activeWeightedAvgPrice;
        } else if (this.selectedValueOption == "QtyCap") {
          price = snapshot.qtyCapWeightedAvgPrice;
        } else {
          price = snapshot.refinedWeightedAvgPrice;
        }
        marketplace.previousPrice = price;
      }
      return price;
    },
    _buildChart() {
      apiSnapshots.getSnapshotsHistory(this.catCodeString, {
        includeSoldItems: true,
        filter: this.selectedValueOption,
        timeFrameMonths: this.timeFrame,
      }).then((data) => {
        this.snapshots = data.map(s => ({ ...s, scanEndDateTime: new Date(s.scanEndDateTime) }));

        if (this.includeAcumaticaPrices) {
          // Remove acumatica prices that are before the first snapshot, except for one
          const firstGreaterIndex = this.acumaticaPrices.findIndex(ap => ap.date >= this.snapshots[0].scanEndDateTime);
          let cutoffIndex;
          if (firstGreaterIndex > 1) {
            cutoffIndex = firstGreaterIndex - 1;
          } else {
            cutoffIndex = 0;
          }
          this.acumaticaPrices = this.acumaticaPrices.slice(cutoffIndex);
        }

        // Initialize an empty array for the months
        let lastXMonths = [];

        // Create a new Date object to track the current date beign processed
        const now = new Date();
        let timeFrameMonths = Number(this.timeFrame);
        if (isNaN(timeFrameMonths) || timeFrameMonths <= 0) {
          timeFrameMonths = 40; // Default to 40 months if the time frame is not valid
        }

        let currentDate = new Date(now.setMonth(now.getMonth() - timeFrameMonths));

        // Loop forward 40 months
        for (let i = 0; i <= timeFrameMonths; i++) {
          // Get the month (0-based index, so add 1 for 1-based month)
          let month = currentDate.getMonth() + 1;
          // Get the year
          let year = currentDate.getFullYear();
          // Format as "M/yyyy" and push to the array
          lastXMonths.push({
            label: `${month}/${year}`,
            date: new Date(year, month - 1, 1)
          });
          lastXMonths.push({
            label: '',
            date: new Date(year, month - 1, 9)
          });
          lastXMonths.push({
            label: '',
            date: new Date(year, month - 1, 16)
          });
          lastXMonths.push({
            label: '',
            date: new Date(year, month - 1, 24)
          });
          // Move the date to the next month
          currentDate.setMonth(currentDate.getMonth() + 1);
        }

        this.series = [
          {
            name: "",
            data: lastXMonths.map(m => null),
          },
          {
            name: "",
            data: lastXMonths.map(m => null),
          }
        ];
        const qtyValues = [];
        const priceValues = [];
        for (const marketplace of this.marketplaces) {
          const qtyData = lastXMonths.map(m => this._mapDateToMarketplaceQty(m.date, marketplace));
          const priceData = lastXMonths.map(m => this._mapDateToMarketplacePrice(m.date, marketplace));
          qtyValues.push(...qtyData);
          priceValues.push(...priceData);

          this.series.push({
            name: `${marketplace.name} Qty`,
            data: qtyData,
          });

          this.series.push({
            name: `${marketplace.name} Price`,
            data: priceData,
          });
        }

        let acumaticaBaseData = [];
        let acumaticaOverstockData = [];
        if (this.includeAcumaticaPrices) {
          acumaticaBaseData = lastXMonths.map(m => this._mapDateToAcumaticaPrice(m.date, 'basePrice'));
          acumaticaOverstockData = lastXMonths.map(m => this._mapDateToAcumaticaPrice(m.date, 'overstockPrice'));
          priceValues.push(...acumaticaBaseData, ...acumaticaOverstockData);
        }

        const validQty = qtyValues.filter(v => v != null);
        const validPrice = priceValues.filter(v => v != null);
        const maxQty = validQty.length ? Math.max(...validQty) : 0;
        const minPrice = this.startYAxisAtZero ? 0 : (validPrice.length ? Math.min(...validPrice) : undefined);
        const maxPrice = validPrice.length ? Math.max(...validPrice) : undefined;

        let acumaticaYAxisEntries = [];
        if (this.includeAcumaticaPrices) {
          this.series.push({
            name: "Acumatica Base Price",
            color: "#0000FF66",
            data: acumaticaBaseData,
          });

          this.series.push({
            name: "Acumatica Overstock Price",
            color: "#0000FFDD",
            data: acumaticaOverstockData,
          });

          acumaticaYAxisEntries = [
            {
              show: false,
              // title: { text: 'Acumatica Base Price', style: { color: 'darkred' } },
              min: minPrice,
              max: maxPrice,
            },
            {
              show: false,
              // title: { text: 'Acumatica Overstock Price', style: { color: 'red' } },
              min: minPrice,
              max: maxPrice,
            }
          ];
        }

        const yaxis = [
          {
            title: { text: 'Qty', style: { color: '#000000AA' } },
            show: true,
            min: 0,
            max: maxQty + 5 - maxQty % 5,
          },
          {
            title: { text: 'Price', style: { color: '#000000AA' } },
            show: true,
            min: minPrice,
            max: maxPrice,
          }
        ];
        for (const _ of this.marketplaces) {
          yaxis.push({
            show: false,
            min: 0,
            max: maxQty + 5 - maxQty % 5,
          });

          yaxis.push({
            show: false,
            min: minPrice,
            max: maxPrice,
          });
        }
        this.chartOptions = {
          title: { text: this.selectedValueOption + ' Listings Snapshot History' },
          xaxis: {
            categories: lastXMonths.map(m => m.label),
          },
          yaxis: [
            // {
            //   show: true,
            //   title: { text: 'Qty', style: { color: 'blue' } },
            //   // Set the min of the graph to the min of the series.
            //   // By default, the x axis starts at 0.
            //   min: 0,
            //   max: maxQty + 5 - maxQty % 5,
            // }, {
            //   show: true,
            //   title: { text: 'Price', style: { color: 'green' } },
            //   // Set the min of the graph to the min of the series.
            //   // By default, the x axis starts at 0.
            //   min: minPrice,
            //   max: maxPrice,
            // },
            ...yaxis,
            ...acumaticaYAxisEntries
          ]
        };
      });
    }
  }
}

function findLastIndex(array, callback) {
  for (let i = array.length - 1; i >= 0; i--) {
    if (callback(array[i], i, array)) {
      return i; // Return the index of the first match in reverse order
    }
  }
  return -1; // Return -1 if no match is found
}
</script>

<style>
#includeAcumaticaPrice .theme--light.v-label {
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
}

#startAtZero .theme--light.v-label,
#timeFrame .theme--light.v-label {
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
}
</style>